import { LoadMode } from "./index195.js";
import { Side } from "./index242.js";
const mainLoadOptions = {
  [LoadMode.dynamic]: [void 0, Side.left, Side.right],
  [LoadMode.double]: [void 0],
  [LoadMode.single]: [Side.left]
};
export {
  mainLoadOptions
};
//# sourceMappingURL=index247.js.map
